import React, { useState, useEffect } from "react";
import { AssortGroup } from "../../../models/AssortGroup";
import "./style.scss";
import "../../../../style/block.scss";
import "../../../../style/feature.scss";
import "../../../../style/buttons.scss";
import "../../../../style/hovers.scss";
import { BsCalendarRange } from "react-icons/bs";
import { MdOutlineAddShoppingCart } from "react-icons/md";
import useBasketManager from "../../FinalizePage/hooks/useBasketManager";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import { useTranslation } from "react-i18next";
import EAProductCard from "../../shared/ProductCard/EAProductCard";
import PassModal from "./PassModal";
import getId from "../../../../utils/getId";
import useParentMessage from "../../../../utils/hooks/useParentMessage";
import EAProductBanner from "../../shared/ProductBanner/EAProductBanner";
import { SaleStep } from "../../../store/stepSaleConfig/stepSaleConfigReducer";
import { FINALIZE_PAGE } from "../../../routes";
import { useNavigate } from "react-router-dom";
import EAAlert from "../../shared/EAAlert";

interface IProps {
  item: AssortGroup;
  saleStep?: SaleStep;
  isSelected?: boolean;
  onModalClose?: () => void;
  onPassSelect?: () => void;
  selectedDate: Date;
  setDateBetween: (date: Date) => void;
  isHorizontal?: boolean;
  highlightBanner?: boolean;
  bannerLabel?: string;
  customMainPrice?: string;
  crossedPrice?: string;
  additionalPriceInfo?: string;
  highlightedFeatures?: string[];
}

const SinglePass: React.FC<IProps> = ({
  item,
  saleStep,
  isSelected = false,
  onModalClose,
  onPassSelect,
  selectedDate,
  setDateBetween,
  isHorizontal = false,
  highlightBanner,
  bannerLabel,
  customMainPrice,
  crossedPrice,
  additionalPriceInfo,
  highlightedFeatures,
}) => {
  const { scrollToTop } = useParentMessage();
  const { t } = useTranslation();
  const [open, setOpen] = useState(isSelected);
  const [addError, setAddError] = useState("");
  const { handleAddBasketLimited } = useBasketManager();
  const saleConfiguration = useSelector((state: State) => state.config.configuration);

  useEffect(() => {
    if (isSelected) {
      setOpen(true);
    }
    return () => {
      if (!isSelected) {
        setOpen(false);
      }
    };
  }, [isSelected]);

  const handleClose = () => {
    setOpen(false);
    onModalClose?.();
  };

  const onClickSelectButton = () => {
    setOpen(true);
    onPassSelect?.();
  };

  const getButtonTitle = () => {
    if (saleConfiguration.passSale_ChooseDateAtSale) {
      return t("wybierz");
    } else {
      return t("dodaj");
    }
  };

  const getAdditionalPriceInfo = () => {
    return `${t("waznosc")} ${item.dayValidate} ${t("dni")}`;
  };

  const getStartIcon = () => {
    if (saleConfiguration.passSale_ChooseDateAtSale) {
      return <BsCalendarRange />;
    } else {
      return <MdOutlineAddShoppingCart />;
    }
  };

  const handleOnClick = async () => {
    if (saleConfiguration.passSale_ChooseDateAtSale) {
      onClickSelectButton();
    } else {
      setAddError("");
      const result = await handleAddBasketLimited(item, 1);
      if (!result?.ok) {
        setAddError(result?.error ?? "");
      }
    }
  };
  const navigate = useNavigate();
  const productProps = {
    key: getId(item),
    title: item.displayWebName,
    pictureUrl: item.picture,
    description: item.description,
    mainPrice: item.price,
    additionalPriceInfo: getAdditionalPriceInfo(),
    buttonTitle: getButtonTitle(),
    buttonStartIcon: getStartIcon(),
    onClick: handleOnClick,
  };

  return (
    <>
      {isHorizontal ? (
        <EAProductBanner
          {...productProps}
          mainPrice = {
            customMainPrice 
              ? customMainPrice.replace("{{price}}", item.price.toFixed(2).toString()) + " zł" 
              : item.price.toFixed(2) + " zł"
          }
          crossedPrice={crossedPrice ? crossedPrice.replace("{{price}}", item.price.toFixed(2).toString()) : ""}
          highlightBanner={highlightBanner}
          bannerLabel={bannerLabel}
          additionalPriceInfo={additionalPriceInfo}
          highlightedFeatures={highlightedFeatures}
          loginRequired={saleStep?.loginRequired}
        />
      ) : (
        <EAProductCard {...productProps} listPrice={item.listPrice} />
      )}

      <PassModal
        isOpen={open}
        onClose={handleClose}
        pass={item}
        selectedDate={selectedDate}
        setDateBetween={setDateBetween}
        errorMessage={addError}
        onAddToBasket={async () => {
          setAddError("");
          const result = await handleAddBasketLimited(item, 1, selectedDate);
          if (!result?.ok) {
            setAddError(result?.error ?? "");
            return;
          }
          handleClose();
          scrollToTop();
          if (saleConfiguration.popupAfterAddTicket === false) {
            setTimeout(() => {
              navigate(FINALIZE_PAGE);
            }, 100);
          }
        }}
      />
      {addError && !open && <EAAlert type="error" message={addError} compact />}
    </>
  );
};

export default SinglePass;
